import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-terms-accept-request',
  templateUrl: './modal-terms-accept-request.component.html',
  styleUrls: ['./modal-terms-accept-request.component.css']
})
export class ModalTermsAcceptRequestComponent implements OnInit {
  bodyTranslation: string
  constructor( public dialogRef: MatDialogRef<ModalTermsAcceptRequestComponent>, private translate: TranslateService) { }

  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit(){
    
  }
}
